import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { storeSession, clearSession } from "../../authClient";
import { FennScreen } from "../FennLoader";

// ─────────────────────────────────────────────────────────────────────────────
// /auth/handoff#code=… — the Android app opening the Studio in its WebView.
//
// The app asked POST /api/mobile/handoff for a one-time, 60-second code and put
// it in the URL FRAGMENT, which browsers never send to a server, so it cannot
// end up in an access log. It is read here, removed from the address bar at
// once, and traded for this WebView's own session.
// ─────────────────────────────────────────────────────────────────────────────

export default function Handoff() {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const code = new URLSearchParams(window.location.hash.slice(1)).get("code");
    window.history.replaceState({}, "", "/auth/handoff"); // drop the code from history
    if (!code) { setFailed(true); return; }

    let cancelled = false;
    clearSession(); // never mix this session with one left over in the WebView
    axios.post("/api/auth/exchange", { code }, { __noAuthRedirect: true })
      .then(({ data }) => {
        if (cancelled) return;
        if (!data?.token) throw new Error("no token");
        storeSession(data);
        navigate("/home", { replace: true });
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [navigate]);

  if (failed) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, textAlign: "center",
        background: "#100F27", color: "#EFE3CC", fontFamily: "'DM Sans', system-ui, sans-serif" }}>
        <div>
          <p style={{ fontSize: 18, fontWeight: 700, margin: "0 0 8px" }}>This link has expired</p>
          <p style={{ color: "#ABA5C9", margin: 0 }}>Go back to the Fennira app and open the Studio again.</p>
        </div>
      </div>
    );
  }
  return <FennScreen label="Opening your studio" />;
}
